export const bodyFont = '\'Arial\', sans-serif'
